import { useCallback } from 'react';

import { IActivity, ILog } from '@/interfaces/logs';
import { store } from '@/redux/store';
import socket from '@/services/socket';
import { BUILD_NUMBER } from '@/settings';

export const useLog = () => {
  const log = useCallback((data: ILog) => {
    if (!data?.additionalData?.ups_usr) return;
    socket.emit('log', {
      additionalData: data.additionalData,
      context: `nutror.front.${data.context}`,
      environment: 'nutrorv3'
    });
  }, []);

  const activity = useCallback((data: IActivity) => {
    const user = store.getState().auth.user;
    if (!user?.id) return;
    socket.emit('log', {
      additionalData: {
        action: data.context,
        referer: window.location.href,
        version: BUILD_NUMBER,
        ...data.additionalData
      },
      context: `nutror.user.${data.context}`,
      environment: 'nutror-activity'
    });
  }, []);

  return {
    log,
    activity
  };
};
